import { Box, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import CustomButton from "../UIElements/CustomButton";
import "../components-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import PasswordInput from "../UIElements/PasswordInput/PasswordInput";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../../services/auth/password.service";
import { passwordRegex } from "../../consts";
import PasswordRequirementsList from "../Common/PasswordRequirementsList";
import { RoutesEnum } from "../../router/routes";

const passwordNotValideMsg = "Veuillez renseigner un mot de passe valide";

const validationSchema = yup.object({
    password: yup
        .string()
        .matches(passwordRegex, passwordNotValideMsg)
        .required("Nouveau mot de passe requis"),
    confirmNewPassWord: yup
        .string()
        .oneOf([yup.ref("password")], "Les mots de passe ne correspondent pas")
        .required("Confirmation du mot de passe requise"),
});

export default function CHangePasswordForm() {
    const {
        handleSubmit,
        formState: { errors },
        watch,
        control,
    } = useForm({
        defaultValues: {
            password: "",
            confirmNewPassWord: "",
        },
        resolver: yupResolver(validationSchema),
    });

    const navigate = useNavigate();
    const [error, setError] = useState<string>("");
    const [disabled, setDisabled] = useState(false);

    const passwordValue = watch("password");
    const confirmedPassword = watch("confirmNewPassWord");
    const isValidNewPassword = useMemo(
        () => passwordRegex.test(passwordValue ?? ""),
        [passwordValue]
    );

    const onSubmit = async (data: any) => {
        setDisabled(true);
        const queryParameters = new URLSearchParams(window.location.search);
        let token = queryParameters.get("token");
        //console.log("token", token);
        const chPwd = await resetPassword(
            data.password,
            data.confirmNewPassWord,
            token
        );
        if (chPwd.detail) {
            setError(chPwd.detail);
        } else {
            navigate("/" + RoutesEnum.login);
        }
    };

    return (
        <Box className="signup-form-root">
            <Typography className="login-title">
                Nouveau mot de passe
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)} className="signup-form">
                <Controller
                    name="password"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <PasswordInput
                            fullWidth={true}
                            {...others}
                            label={"Nouveau mot de passe"}
                            havePasswordChecker={true}
                            isValidPassword={isValidNewPassword}
                            errortext={errors.password?.message ?? ""}
                            showvisibility={(passwordValue || "").length}
                        />
                    )}
                />
                <Controller
                    name="confirmNewPassWord"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <PasswordInput
                            fullWidth={true}
                            {...others}
                            label={"Nouveau mot de passe"}
                            havePasswordChecker={true}
                            errortext={errors.confirmNewPassWord?.message ?? ""}
                            showvisibility={(confirmedPassword || "").length}
                        />
                    )}
                />
                <PasswordRequirementsList password={passwordValue} />
                <Box
                    sx={{
                        color: "#E51846",
                    }}
                >
                    {error ?? (
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "15px",
                                    md: "17px",
                                },
                                fontWeight: "600",
                                fontFamily: "Roboto",
                                marginBottom: "10px",
                            }}
                        >
                            {error}
                        </Typography>
                    )}
                </Box>

                <CustomButton
                    type="submit"
                    disabled={disabled}
                    label="Confirmer"
                />
            </form>
        </Box>
    );
}
